import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import CapacityChange from "../../components/CapacityChange";
import * as CapacityChangeActions from "../../store/actions/CapacityChange";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import { bindActionCreators } from "redux";

export const CAPACITY_CHANGE_TABS = {
  request: 0,
  approve: 1,
};

const GigsCapacityChange = ({
  allMenuActions,
  getUserAttributes,
  userAttributes,
}) => {
  const capacityChangeActions =
    MenuActionsMappings[MenuNames.MANUAL_SLOT_CAPACITY_UPDATE];
  const [defaultPage, setDefaultPage] = useState(CAPACITY_CHANGE_TABS.request);

  useEffect(() => {
    const approveAction = allMenuActions[capacityChangeActions.APPROVE];
    const createAction = allMenuActions[capacityChangeActions.CREATE];
    if (!createAction && approveAction) {
      setDefaultPage(CAPACITY_CHANGE_TABS.approve);
    }
    getUserAttributes(capacityChangeActions.LIST);
  }, [allMenuActions]);

  return (
    <CapacityChange defaultPage={defaultPage} userAttributes={userAttributes} />
  );
};

const mapStateToProps = (state) => {
  const { MenuActions, CapacityChange } = state;
  return {
    allMenuActions: MenuActions.allMenuActions,
    userAttributes: CapacityChange.userAttributes,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    getUserAttributes: bindActionCreators(
      CapacityChangeActions.getCapacityChangeUserAttributes,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GigsCapacityChange);
